import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';
import projectGrouping from '../../../../../../redux/project_grouping';
import styles from './ReportStatus.module.less';
import Loader from '../../../../../generic/Loader';
import { useDialogContext } from '../../../../../../contexts/DialogContext';
import { Link } from '../../../../../generic';
import { useReportUrl } from '../../../../../shared/publicPortal/hooks';

type Props = {
  isLoading: boolean;
  isDisabled: boolean;
  onUnpublishReport: () => Promise<void>;
  reportType: 'SBOM' | 'Attribution';
};

const ReportStatus: VoidFunctionComponent<Props> = ({ isLoading, onUnpublishReport, reportType, isDisabled }) => {
  const { url: reportUrl, isPublic: isPublicReport } = useReportUrl();
  const reportPublishedStatus = useSelector(projectGrouping.selectors.getReportPublishedStatus);
  const reportLastPublishedAt = useSelector(projectGrouping.selectors.getReportLastPublishedAt);
  const isReportPublished = useSelector(projectGrouping.selectors.getIsReportPublished);
  const { onConfirm } = useDialogContext();

  return (
    <div className={styles.status}>
      {isReportPublished ? (
        <>
          <div>Last published {reportLastPublishedAt}</div>
          {isPublicReport && reportUrl && ( // View report displayed if report is public and reportUrl present
            <>
              <div className={styles.separator}>&bull;</div>
              <div className={styles.reportLink}>
                <Link to={reportUrl} openInNewTab>
                  View report
                </Link>
              </div>
            </>
          )}
          <div className={styles.separator}>&bull;</div>
          {isLoading ? (
            <Loader />
          ) : (
            <button
              disabled={isDisabled}
              type="button"
              className={styles.unpublishButton}
              onClick={() => {
                onConfirm({
                  title: `Unpublish ${reportType}`,
                  body: (
                    <div className={styles.dialog}>
                      <p>
                        This will remove the {reportType} for this release version. You can republish it from the
                        release group in FOSSA.
                      </p>
                    </div>
                  ),
                  onConfirm: onUnpublishReport,
                });
              }}
            >
              {isDisabled ? 'Unpublished' : 'Unpublish'}
            </button>
          )}
        </>
      ) : (
        <div>{reportPublishedStatus}</div>
      )}
    </div>
  );
};

export default ReportStatus;
